export default __webpack_public_path__ + "static/media/4.6a32c531.png";